import React from 'react';
import PropTypes from 'prop-types';
import { createUseStyles } from 'react-jss';
import classNames from 'classnames';
import { CarBrandIcon } from '../car_brand_icon/car_brand_icon';

const useStyles = createUseStyles({
    container: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        flexWrap: 'wrap',
        marginBottom: '-1.5rem'
    },
    label: {
        fontWeight: '600',
        marginBottom: '0rem',
        paddingLeft: '0.5rem',
        paddingRight: '0.5rem',
        fontSize: '1.7rem'
    },
    carBrandContainer: {
        display: 'flex',
        '& img': {
            height: '1.25rem'
        }
    }
});

const DetailsRow = ({ year, make, model, body, fuel, className }) => {
    const classes = useStyles();

    const renderIfNotNull = (value) => {
        if (value) {
            return (
                <>
                    |
                    <p className={classes.label}>
                        {value}
                        {' '}
                    </p>
                </>
            );
        }

        return null;
    };

    return (
        <div className={classNames(classes.container, className)}>
            <p className={classes.label}>
                {year}
                {' '}
            </p>
            |
            <div className={classes.carBrandContainer}>
                {' '}
                <CarBrandIcon />
            </div>
            <p className={classes.label}>
                {make}
                {' '}
            </p>
            |
            <p className={classes.label}>
                {model}
                {' '}
            </p>
            {renderIfNotNull(body)}
            {renderIfNotNull(fuel)}
        </div>
    );
};

DetailsRow.propTypes = {
    year: PropTypes.string,
    make: PropTypes.string,
    model: PropTypes.string,
    body: PropTypes.string,
    fuel: PropTypes.string,
    className: PropTypes.string
};

export { DetailsRow };
